import { AuthProviderName, Environment, Language } from '../app/core/models/environment';
import { NgxLoggerLevel } from 'ngx-logger';

export const environment: Environment = {
  production: true,
  defaultLanguage: Language.fr,
  logger: {
    level: NgxLoggerLevel.DEBUG,
  },
  firebase: {
    useFirebaseEmulator: false,
    appCheckEnabled: true,
    config: {
      apiKey: 'AIzaSyAL1_400uAVz493LOfE-vq9cxQmBiQFN9c',
      authDomain: 'accounts.app.test-6.movinmotion.net',
      databaseURL: 'https://movinmotion-test-6.firebaseio.com',
      projectId: 'movinmotion-test-6',
      storageBucket: 'movinmotion-test-6.appspot.com',
      messagingSenderId: '312636571496',
      appId: '1:312636571496:web:fbeee5af4483ce9c9aa0dd',
      keyId: '6LdWpgssAAAAAJDRpwbFP_WUyysu-U64TQzf2wzy',
    },
  },
  queryParamsKeys: {
    redirectUrl: 'mmr',
    resetPassword: 'mmrp',
    changePassword: 'mmcp',
    email: 'mme',
    autoConnectUrl: 'mmac',
    language: 'mml',
    display: 'mmd',
    providerConnection: 'mmpc',
  },
  displayByAppHostEnabled: true,
  providers: {
    [AuthProviderName.myId]: {
      id: 'saml.dlp-myid',
      enabled: false,
    },
    [AuthProviderName.tohero]: {
      id: 'oidc.tohero',
      enabled: true,
    },
    [AuthProviderName.movinmotion]: {
      id: 'oidc.movinmotion',
      enabled: true,
    },
    [AuthProviderName.deezer]: {
      id: 'oidc.deezer',
      enabled: true,
    },
  },
  subscribeUrl: 'https://www.movinmotion.com/inscription/',
  filmFranceSubscribeUrls: {
    worker: 'https://salarie.app.test-6.movinmotion.net/film-france-talents/signup',
    talents: 'https://talents.app.test-6.movinmotion.net/film-france/signup',
  },
  odalieSubscribeUrl: 'https://odalie2.app.test-6.movinmotion.net/cmbSignup',
  workerSubscribeUrl: 'https://salarie.app.test-6.movinmotion.net/inscription/autonome',
  envName: 'test-6',
  sentryDsn: '',
  thirdParty: {
    mixpanel: {
      enabled: true,
    },
  },
};
